module.exports = __webpack_public_path__ + "img/Asset 37.9d79b810.svg";